/* eslint-disable prettier/prettier */
import { APIResponse } from 'playwright/test';
import { ApiResponse } from '../types/index';
import { apiService } from './api.service';
import { AxiosProgressEvent } from 'axios';

export interface SubmitAssessmentPayload {
	answers?: Record<string, any>;
	files?: File[];
	filePurposes?: string[];
	fileDescriptions?: string[];
}

class AssessmentSubmissionService {
	/**
	 * Submit assessment with files (multipart/form-data)
	 */
	async submitAssessment(
		assessmentId: string,
		payload: SubmitAssessmentPayload,
		onProgress?: (percent: number) => void
	): Promise<ApiResponse> {
		const formData = new FormData();
		console.log('formData', formData);
		// Answers (JSON)
		if (payload.answers) {
			formData.append('answers', JSON.stringify(payload.answers));
		}

		// Files
		payload.files?.forEach(file => {
			formData.append('files', file);
		});

		// Optional metadata per file
		payload.filePurposes?.forEach(p =>
			formData.append('filePurposes[]', p)
		);

		payload.fileDescriptions?.forEach(d =>
			formData.append('fileDescriptions[]', d)
		);

		console.log('calling start assesment submission service');
		const response = await apiService.post<ApiResponse>(
			`submission/${assessmentId}/submit`,
			formData,
			{
				onUploadProgress: (event: AxiosProgressEvent) => {
					if (!event.total) return;

					const percent = Math.round(
						(event.loaded * 100) / event.total
					);

					onProgress?.(percent);
					console.log('returning from service');
				},
			}
		);
		console.log('response from submit', response);

		if (!response.success) {
			throw new Error(response.message || 'Submission failed');
		}
		console.log('response from submit', response);
		return response; // submissionId
	}

	/**
	 * Student: get my submissions for an assessment
	 */
	async getMySubmissions(assessmentId: string) {
		const response = await apiService.get<any[]>(
			`assessment-submission/${assessmentId}/my-submissions`
		);

		if (!response.success) {
			throw new Error(response.message || 'Failed to fetch submissions');
		}

		return response.data;
	}

	/**
	 * Instructor: get all submissions
	 */
	async getAllSubmissions(assessmentId: string) {
		const response = await apiService.get<any[]>(
			`assessment-submission/${assessmentId}/submissions`
		);

		if (!response.success) {
			throw new Error(response.message || 'Failed to fetch submissions');
		}

		return response.data;
	}

	/**
	 * Download submitted file
	 */
	async downloadSubmissionFile(submissionId: string, fileId: string) {
		return apiService.getBlob(
			`assessment-submission/submissions/${submissionId}/files/${fileId}/download`
		);
	}

	// ✅ DELETE submission (student or instructor)
	async deleteSubmission(submissionId: string): Promise<void> {
		const response = await apiService.delete<void>(
			`submission/submissions/${submissionId}`
		);

		if (!response.success) {
			throw new Error(response.message || 'Failed to delete submission');
		}
	}
}

export const assessmentSubmissionService = new AssessmentSubmissionService();
